export default "__VITE_ASSET__Hc52fTLb__"